module.exports = __webpack_public_path__ + "static/media/photo305.61987060.jpg";